import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 9 8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M1.875.292c0 .68-.946.066-1.112.99C.72 1.514.75 6.796.75 6.958l1.086-.764c.127-.091.219-.195.436-.195h3.892c.823 0 1.856.178 2.048-.491.057-.202.017-.334.038-.55.04-.42.75-.354.75 0 0 .556.043.886-.451 1.328a1.5 1.5 0 0 1-1.002.38c-1.665-.006-3.357.013-5.017 0-.21-.002-.202.047-.464.232L.868 7.75c-.236.164-.28.25-.54.25C.183 8 0 7.838 0 7.708V1.25A1.1 1.1 0 0 1 .144.753C.335.353.905 0 1.407 0h.14c.147 0 .328.162.328.292M5.016.138c.495 0 .979.143 1.39.411.412.268.733.648.922 1.093.19.446.24.935.143 1.408a2.4 2.4 0 0 1-.685 1.247c-.35.341-.796.573-1.282.667a2.57 2.57 0 0 1-1.446-.138 2.5 2.5 0 0 1-1.123-.898 2.4 2.4 0 0 1-.422-1.353c0-.646.264-1.266.733-1.723a2.54 2.54 0 0 1 1.77-.714m0 .615c.37 0 .732.107 1.04.307.307.2.547.485.689.817a1.785 1.785 0 0 1-.406 1.985 1.9 1.9 0 0 1-.958.499c-.363.07-.74.034-1.08-.104a1.86 1.86 0 0 1-.84-.67 1.79 1.79 0 0 1 .232-2.3c.35-.342.827-.534 1.323-.534",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h9v8H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }